/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import styled, { css } from "styled-components";
import color from "../_style/color";
import Text from "./Text";
import handleSpaces, { spacingProps } from "../utils/handleSpaces";

const Label = styled(Text).attrs({
  height: "28px",
  color: color.midgray,
  size: "16px",
  as: "label",
})`
  position: absolute;
  top: 0px;
  background-color: transparent;
  cursor: pointer;
  transition: 0.2s;
`;

const Bar = styled.div.attrs((props) => ({
  activeColorBars: props.activeColorBar,
}))`
  height: 1px;
  width: 100%;
  position: relative;
  background-color: ${color.lowgray};
  transition: 0.2s;

  ::before {
    content: "";
    display: block;
    position: absolute;
    width: 0px;
    height: 1px;
    background-color: ${({ activeColorBar }) => activeColorBar || color.primary};
  }
`;

const Container = styled.div.attrs((props) => ({ ...spacingProps(props) }))`
  position: relative;
  background: ${color.light};

  input {
    position: inherit;
    z-index: 1;
    border: none;
    background: transparent;
  }

  input::placeholder {
    color: transparent;
  }

  input:focus {
    outline: 0;
  }

  input:focus ~ ${Label}, input:not(:placeholder-shown) ~ ${Label} {
    top: -20px;
    font-size: 13px;
  }

  input:focus ~ ${Bar}::before {
    width: 100%;
    transition: 0.5s;
  }

  ${(props) =>
    css`
      ${handleSpaces(props)}
    `}
`;

const InputContainer = ({ children, className, activeColorBar, ...otherProps }) => {
  const { props: childrenProps } = children;
  const { placeholder } = childrenProps;
  return (
    <Container className={className} {...otherProps}>
      {children}
      <Bar activeColorBar={activeColorBar} />
      <Label>{placeholder || " "}</Label>
    </Container>
  );
};

export default InputContainer;
